<template >

  <section class="fixed-top">
    <!-- contenido de la pagina -->
    <div id="container" v-bind:class="getPlatformClass()" ref="container"/>
     <v-sheet color="transparent" >
      <v-form v-on:submit.prevent v-model="permitirGuardar">
        <v-container class="transparent">
          <div style="height: 60px"></div>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <span v-if="esNuevo">
                <v-text-field 
                  ref="idSensor"
                  label="Identificador del sensor"
                  prepend-inner-icon="mdi-identifier"
                  :rules="[rvValorNoVacio, rvComprobaridSensor]"
                  counter="14"
                  outlined
                  shaped
                  v-model="idSensor"
                  v-inputfilter-identificadorsensor
                  @keyup.enter="$refs.tipo_sensor.focus()"
                ></v-text-field>
              </span>
              <span v-else>
                <v-text-field
                  disabled
                  prepend-inner-icon="mdi-identifier"
                  v-model="idSensor"
                ></v-text-field>
              </span>
            </v-col>
          </v-row>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-select
                class="mt-n1"
                ref="tipo_sensor"
                label="Tipo de sensor"
                prepend-inner-icon="mdi-alpha-t-circle-outline"
                :rules="[rvComprobarTipoSensor]"
                :items="tiposDeSensores"
                v-model="tipoSensor"
                @keyup.enter="$refs.descripcion.focus()"
              ></v-select>
            </v-col>
          </v-row>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-text-field
                ref="descripcion"
                label="Etiqueta / Descripción"
                prepend-inner-icon="mdi-tag"
                :rules="[rvValorNoVacio]"
                v-model="descripcion"
                @keyup.enter="$refs.ubicacion.focus()"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-text-field
                ref="ubicacion"
                label="Ubicación"
                prepend-inner-icon="mdi-home-map-marker"
                v-model="ubicacion"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <div class="d-flex align-center">
                <v-icon class="mr-1">mdi-palette</v-icon>
                <label
                  class="v-label theme--dark mr-3"
                  style="position: relative"
                  >Color de la tarjeta</label
                >
                <swatches
                  background-color="#101010"
                  v-model="color"
                  popover-y="bottom"
                  swatch-size="36"
                  :swatches="swatches"
                  show-border
                />
              </div>
            </v-col>
          </v-row>

          <!-- -------------- -->

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <div class="mt-5">
                <span class="theme--dark mr-3" style="position: relative">Configuración de alertas:</span>
              </div>
            </v-col>
          </v-row>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <div class="ml-1 mt-4">
                <v-checkbox v-model="alarmaTemperatura" hide-details>
                  <template v-slot:label>
                    <div><v-icon class="mr-1">mdi-thermometer-alert</v-icon> Alerta de temperatura</div>
                  </template>
                </v-checkbox>
              </div>
              <v-range-slider
                v-model="rangoTemperautraAdmitido"
                thumb-label="always"
                class="align-center ml-7 mt-6"
                min="0"
                max="500"
                thumb-size="0"
                hide-details
                :disabled="!alarmaTemperatura"
                color="#388E3C">
                <template v-slot:thumb-label="props">
                  <div :style="estiloTemperaturaRango (props)" >
                  {{ tituloTemperaturaRango1Decimal (props) }}
                  </div>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <div class="ml-1 mt-4">
                <v-checkbox v-model="alarmaHumedad" hide-details>
                  <template v-slot:label>
                    <div><v-icon class="mr-1">mdi-water-percent-alert</v-icon> Alerta de humedad</div>
                  </template>
                </v-checkbox>
              </div>
              <v-range-slider
                v-model="rangoHumedadAdmitido"
                thumb-label="always"
                class="align-center ml-7 mt-6"
                min="0"
                max="100"
                thumb-size="0"
                hide-details
                :disabled="!alarmaHumedad"
                color="#388E3C">
                <template v-slot:thumb-label="props">
                  <div :style="estiloHumedadRango (props)"> <!--style="width: 100px; font-size: 15px; font-weight: 500; fontFamily: roboto; textAlign: center; margin-top: -15px; color: #26A69A"-->
                  {{ tituloHumedadRango (props) }}
                  </div>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>

          <v-row v-if="tipoSensor == 2" no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <div class="ml-1 mt-4">
                <v-checkbox v-model="alarmaPuertaAbierta" hide-details>
                  <template v-slot:label>
                    <div><v-icon class="mr-1">mdi-door-closed</v-icon> Alarma de puerta</div>
                  </template>
                </v-checkbox>
              </div>
            </v-col>
          </v-row>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-switch v-model="recibirNotificacionesDeAlarmas" class="mt-8" hide-details label="Recibir notificaciones de alertas" />
            </v-col>
          </v-row>
        
          <v-row v-if="recibirNotificacionesDeAlarmas" no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-card flat color="transparent">
                <v-subheader class="pl-8" >Tolerancia de<span class="variacion">variación</span>de Temperatura:</v-subheader>
                <v-card-text>
                  <v-slider class="mx-8" style="; margin-top:-15px"
                    v-model="toleranciaTemperaturaAlarmas"
                    min="0"
                    max="50"
                    thumb-size="1"
                    ticks="always"
                    thumb-label="always"
                    thumb-color="blue"
                    track-color="gray"
                    step=0.5>
                    <template v-slot:thumb-label="props">
                        <div style="width: 100px; font-size: 15px; font-weight: 500; fontFamily: roboto; textAlign: center; margin-top: -15px; color: #EF5350">
                         {{ "± " + props.value + "°" }}
                        </div>
                    </template>
                  </v-slider>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="recibirNotificacionesDeAlarmas" no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-card flat color="transparent" style="; margin-top:-45px">
                <v-subheader class="pl-8" >Tolerancia de<span class="variacion">variación</span>de Humedad:</v-subheader>
                <v-card-text>
                  <v-slider class="mx-8" style="; margin-top:-15px"
                    v-model="toleranciaHumedadAlarmas"
                    min="0"
                    max="100"
                    thumb-size="1"
                    ticks="always"
                    thumb-label="always"
                    thumb-color="blue"
                    track-color="gray"
                    step=5>
                    <template v-slot:thumb-label="props">
                      <div style="width: 100px; font-size: 15px; font-weight: 500; fontFamily: roboto; textAlign: center; margin-top: -12px; color: #26A69A">
                      {{ "± " + props.value + "% HR" }}
                      </div>
                    </template>
                  </v-slider>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-switch v-model="recibirAlarmasPorCorreoElectronico" class="mt-4" hide-details label="Recibir alertas por correo electrónico" />
            </v-col>
          </v-row>

          <v-row v-if="recibirAlarmasPorCorreoElectronico" no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-card flat color="transparent">
                <v-subheader class="pl-8" >Tolerancia de<span class="variacion">variación</span>de Temperatura:</v-subheader>
                <v-card-text>
                  <v-slider class="mx-8" style="; margin-top:-15px"
                    v-model="toleranciaTemperaturaEmail"
                    min="0"
                    max="50"
                    thumb-size="1"
                    ticks="always"
                    thumb-label="always"
                    thumb-color="blue"
                    track-color="gray"
                    step=0.5>
                    <template v-slot:thumb-label="props">
                        <div style="width: 100px; font-size: 15px; font-weight: 500; fontFamily: roboto; textAlign: center; margin-top: -15px; color: #EF5350">
                         {{ "± " + props.value + "°" }}
                        </div>
                    </template>
                  </v-slider>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="recibirAlarmasPorCorreoElectronico" no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-card flat color="transparent" style="; margin-top:-45px">
                <v-subheader class="pl-8">Tolerancia de<span class="variacion">variación</span>de Humedad:</v-subheader>
                <v-card-text>
                  <v-slider class="mx-8" style="; margin-top:-15px"
                    v-model="toleranciaHumedadEmail"
                    min="0"
                    max="100"
                    thumb-size="1"
                    ticks="always"
                    thumb-label="always"
                    thumb-color="blue"
                    track-color="gray"
                    step=5>
                    <template v-slot:thumb-label="props">
                      <div style="width: 100px; font-size: 15px; font-weight: 500; fontFamily: roboto; textAlign: center; margin-top: -12px; color: #26A69A">
                      {{ "± " + props.value + "% HR" }}
                      </div>
                    </template>
                  </v-slider>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-row no-gutters justify="center" >
            <v-col cols="10" md="6" lg="5">
              <v-switch v-model="publicarAlarmasPorMqtt" hide-details label="Publicar alertas por MQTT"/>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5">
              <v-switch v-model="publicarEstadoPorMqtt" hide-details label="Publicar estado por MQTT"/>
            </v-col>
          </v-row>        

          <v-row no-gutters justify="center" v-if="!esNuevo">  
            <v-col cols="10" md="6" lg="5" v-if="publicarAlarmasPorMqtt || publicarEstadoPorMqtt">
              <v-card class="mt-1" flat tile color="transparent">
                <v-card-text style="text-align: center; font-style:italic; font-size:10px; color:gray">Click en icono para copiar su Topic MQTT al portapapeles</v-card-text>
              </v-card>
              <v-sheet class="d-flex align-center justify-center" style="margin-top:-10px" color="transparent">

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mr-2" v-bind="attrs" v-on="on" outlined v-on:click.prevent="copyTopicToClipboard('estado')">
                      <v-icon>mdi-chip</v-icon>
                    </v-btn>
                  </template>
                  <span>Estado</span>
                </v-tooltip>


                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mr-2" v-bind="attrs" v-on="on" outlined v-on:click.prevent="copyTopicToClipboard('temperatura')">
                      <v-icon>mdi-thermometer-alert</v-icon>
                    </v-btn>
                  </template>
                  <span>Temperatura</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mr-2" v-bind="attrs" v-on="on" outlined v-on:click.prevent="copyTopicToClipboard('humedad')">
                      <v-icon >mdi-water-percent-alert</v-icon>
                    </v-btn>
                  </template>
                  <span>Humedad</span>
                </v-tooltip>


                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mr-2" v-bind="attrs" v-on="on" outlined v-on:click.prevent="copyTopicToClipboard('ambos')">
                  <v-icon>mdi-thermometer-alert</v-icon><v-icon>mdi-water-percent-alert</v-icon>
                    </v-btn>
                  </template>
                  <span>Temperatura y Humedad</span>
                </v-tooltip>

              </v-sheet>
            </v-col>
          </v-row>

          <v-row no-gutters justify="center">
            <v-col cols="10" md="6" lg="5" class="text-right">
              <v-btn
                v-if="!esNuevo"
                color="red"
                style="margin-top: 20px"
                text
                @click="eliminar()">
                <v-icon class="mr-1">mdi-delete</v-icon>
                Eliminar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-dialog v-model="cuadroEmergente.mostrar" max-width="400">
        <v-card light>
          <v-card-title class="headline"><v-icon color="#303030" x-large class="mr-2" v-html="cuadroEmergente.icono"></v-icon><span v-html="cuadroEmergente.titulo"></span></v-card-title>
          <v-card-text><span v-html="cuadroEmergente.texto"></span></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="cuadroEmergente.accion()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div style="height: 10px"></div>

    </v-sheet>

    <v-snackbar
      no-gutters
      :value="mostrarNotificacion"
      vertical
      color="#4A148C"
      elevation="6">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>mdi-clipboard</v-icon>
        <v-layout column>
          <div>
            <span class="notification">Portapapeles</span>
          </div>
          <div>{{ mensajeNotificacion }}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>

  </section>
  
</template>

<script>
import * as Validadores from "@/validadores.js";
import api from "@/api";
import util from "@/util";

import Swatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

function miFuncionDeHash (str) {
    let hash = 0;

    str += '-rackon.equinsanetworking'; // le añadimos un poco de sal...
    for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        hash = ((hash<<5)-hash)+char+(char%5);
        hash = hash & 0xFFFF; // lo convertimos a un entero de 32bit
    }
    let resultado = (hash % 0xFF) + 0x100;
    return resultado.toString(16).slice (-2).toUpperCase();
}

export default {
  name: "guardar",

  components: { Swatches },

  data: () => ({
    buttonTitle: "",
    toleranciaTemperaturaEmail: 5,
    toleranciaHumedadEmail: 10,
    toleranciaTemperaturaAlarmas: 5,
    toleranciaHumedadAlarmas: 10,
    cuadroEmergente: {
      mostrar: false,
      titulo: "",
      texto: ""
    },
    mostrarNotificacion: false,
    mensajeNotificacion: "",
    mqttIDTemperatura: "",
    mqttIDHumedad: "",
    mqttIDAmbos: "",
    mqttIDEstado: "",
    permitirGuardar: false,
    esNuevo: false,

    tiposDeSensores: [ { text: 'Temperatura/humedad', value: 1 }, { text: 'Temperatura/humedad + Puerta', value: 2 } ],
    swatches: [
      "#151a15",
      "#303430",
      "#5c3d3d",
      "#5c523d",
      "#525c3d",
      "#3d5c3d",
      "#3d5c52",
      "#3d525c",
      "#3d3d5c",
      "#523d5c",
      "#5c3d52",
      "#592626",
      "#594826",
      "#485926",
      "#265926",
      "#265948",
      "#264859",
      "#262659",
      "#482659",
      "#592648",
    ],

    titulo: "",
    idSensor: "",
    tipoSensor: 1,
    descripcion: "",
    ubicacion: "",
    color: "#303430",
    alarmaTemperatura: true,
    rangoTemperautraAdmitido: [120, 260],
    alarmaHumedad: true,
    rangoHumedadAdmitido: [0, 40],
    alarmaPuertaAbierta: true,
    recibirNotificacionesDeAlarmas: true,
    recibirAlarmasPorCorreoElectronico: false,
    publicarAlarmasPorMqtt: false,
    publicarEstadoPorMqtt: false
  }),

  methods: {

    saveSensordata() {
      this.guardar()
    },


    getPlatformClass(objeto){
      return util.getPlatformClass(objeto);
    },
    getPlatformClassH(objeto){
      return util.getPlatformClassH(objeto);
    },

    copyTopicToClipboard(topic) {
        const el = document.createElement('textarea');  
        el.value = this.mqttIDTemperatura;
        if (topic=="humedad") el.value=this.mqttIDHumedad
        else if (topic=="ambos") el.value=this.mqttIDAmbos;                                
        else if (topic=="estado") el.value=this.mqttIDEstado;                                
        el.setAttribute('readonly', '');                
        el.style.position = 'absolute';                     
        el.style.left = '-9999px';                      
        document.body.appendChild(el);                  
        const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
        el.select();                                    
        document.execCommand('copy');                   
        document.body.removeChild(el);                  
        if (selected) {                                 
          document.getSelection().removeAllRanges();    
          document.getSelection().addRange(selected);   
        }
        this.mensajeNotificacion =  'El \'Topic\' ha sido copiado al portapapeles';
        this.mostrarNotificacion = true;
        let manejador = setTimeout (() => { 
              this.mostrarNotificacion = false;
              this.$nextTick(() => {
                clearTimeout(manejador);
                window.getSelection().removeAllRanges();
              })        
        }, 1500);        
    },
    rvValorNoVacio(valor) {
      return Validadores.esValorNoVacio(valor) || "Requerido";
    },
    rvComprobaridSensor(valor) {
      try {
        if (valor.length != 14)
          return "Id. de sensor debe tener 14 caracteres";
        const hash = miFuncionDeHash (valor.slice (2));
        if (hash != valor.slice (0,2))
          return "Id. de sensor incorrecto";
      } catch (e) {
        return e;
      }
      return true;
    },
    rvComprobarTipoSensor(valor) {
      return valor > 0 || "Requerido";
    },

    tituloTemperaturaRango1Decimal (props) {
      let titulo = "";
      if (props.value < this.rangoTemperautraAdmitido[1])
        titulo = "< ";
      else if (props.value > this.rangoTemperautraAdmitido[0])
        titulo = "> ";
      titulo = titulo + (Math.round (props.value / 5) * 0.5) + " °C";
      return titulo;
    },
    estiloTemperaturaRango (props) {
      let estilo =  {
                      width: "100px",
                      fontSize: "15px",
                      fontWeight: "700",
                      fontFamily: "roboto",
                      textAlign: "center"
                    };
      if (props.value < this.rangoTemperautraAdmitido[1]) {
        estilo.color = "#42A5F5";
        estilo.marginTop = "-6px";
      } else if (props.value > this.rangoTemperautraAdmitido[0]) {
        estilo.color = "#EF5350";
        estilo.marginTop = "-31px";
      }

      return estilo;
    },

    tituloHumedadRango (props) {
      let titulo = "";
      if (props.value < this.rangoHumedadAdmitido[1])
        titulo = "< ";
      else if (props.value > this.rangoHumedadAdmitido[0])
        titulo = "> ";
      titulo = titulo + props.value + " % HR";
      return titulo;
    },
    estiloHumedadRango (props) {
      let estilo =  {
                      width: "100px",
                      fontSize: "15px",
                      fontWeight: "700",
                      fontFamily: "roboto",
                      textAlign: "center"
                    };
      if (props.value < this.rangoHumedadAdmitido[1]) {
        estilo.color = "#42A5F5";
        estilo.marginTop = "-6px";
      } else if (props.value > this.rangoHumedadAdmitido[0]) {
        estilo.color = "#EF5350";
        estilo.marginTop = "-31px";
      }

      return estilo;
    },

    atras() {
      this.$router.go(-1);
    },
    guardar() {
      this.$global.cargando = true;
      if (this.rangoTemperautraAdmitido[0] > this.rangoTemperautraAdmitido[1])
        this.rangoTemperautraAdmitido.reverse();
      if (this.rangoHumedadAdmitido[0] > this.rangoHumedadAdmitido[1])
        this.rangoHumedadAdmitido.reverse();
      api
        .guardarSensor(
          this.esNuevo,
          this.idSensor.slice(2),
          this.tipoSensor,
          this.descripcion,
          this.ubicacion,
          this.color,
          this.alarmaTemperatura,
          Math.round (this.rangoTemperautraAdmitido[0] / 5) * 0.5,
          Math.round (this.rangoTemperautraAdmitido[1] / 5) * 0.5,
          this.alarmaHumedad,
          this.rangoHumedadAdmitido[0],
          this.rangoHumedadAdmitido[1],
          this.alarmaPuertaAbierta,
          this.recibirNotificacionesDeAlarmas,
          this.recibirAlarmasPorCorreoElectronico,
          this.publicarAlarmasPorMqtt,
          this.publicarEstadoPorMqtt,
          this.toleranciaTemperaturaEmail,
          this.toleranciaHumedadEmail,
          this.toleranciaTemperaturaAlarmas,
          this.toleranciaHumedadAlarmas
        )
        .then(() => {
          this.$router.replace("/panel");
        })
        .catch((e) => {
          console.log(e);

          this.cuadroEmergente.icono = "mdi-emoticon-confused-outline";
          this.cuadroEmergente.titulo = "Error guardando sensor";
          this.cuadroEmergente.texto = e.response.data.error
            ? e.response.data.error
            : e;
          this.cuadroEmergente.accion = () => { this.cuadroEmergente.mostrar = false };
          this.cuadroEmergente.mostrar = true;
        })
        .finally(() => {
          this.$global.cargando = false;
        });
    },
    eliminar() {
      this.$root.$confirm
        .open(
          "Eliminar sensor",
          `¿Estás seguro que deseas eliminar el sensor "${this.descripcion}"?`,
          { color: "#F04040" }
        )
        .then((confirm) => {
          if (confirm) {
            this.$global.cargando = true;
            api
              .eliminarSensor(this.idSensor.slice(2))
              .then(() => {
                this.$router.replace("/panel");
              })
              .catch((e) => {
                console.log(e);
              })
              .finally(() => {
                this.$global.cargando = false;
              });
          }
        });
    },
  },

  watch: {
    
  },
  
  mounted() {
    window.scrollTo( 0, 0 );

    if (this.$route.name == "modificarSensor") {
      this.titulo = "Modificar sensor";
      this.idSensor = this.$route.params.id;
      this.$global.cargando = true;
      api
        .cargarSensor(this.idSensor)
        .then((r) => {
          this.tipoSensor = r.data.tipoSensor;
          this.descripcion = r.data.descripcion;
          this.ubicacion = r.data.localizacion;
          this.color = r.data.color;
          this.alarmaTemperatura = r.data.alarmaTemperatura;
          this.$set (this.rangoTemperautraAdmitido, 0, r.data.alarmaTemperaturaPorDebajoDe * 10);
          this.$set (this.rangoTemperautraAdmitido, 1, r.data.alarmaTemperaturaPorEncimaDe * 10);
          this.alarmaHumedad = r.data.alarmaHumedad;
          this.$set (this.rangoHumedadAdmitido, 0, r.data.alarmaHumedadPorDebajoDe);
          this.$set (this.rangoHumedadAdmitido, 1, r.data.alarmaHumedadPorEncimaDe);
          this.alarmaPuertaAbierta = r.data.alarmaPuertaAbierta;
          this.recibirNotificacionesDeAlarmas = r.data.notificacionesAlerta;
          this.recibirAlarmasPorCorreoElectronico = r.data.correosAlerta;
          this.publicarAlarmasPorMqtt = r.data.mqttAlerta;
          this.publicarEstadoPorMqtt = r.data.mqttEstado;
          this.toleranciaTemperaturaEmail = r.data.toleranciaTemperaturaEmail;
          this.toleranciaHumedadEmail = r.data.toleranciaHumedadEmail;
          this.toleranciaTemperaturaAlarmas = r.data.toleranciaTemperaturaAlarmas;
          this.toleranciaHumedadAlarmas = r.data.toleranciaHumedadAlarmas;
        })
        .catch((e) => {
          console.log(e);
          this.$router.go(-1);
        })
        .finally(() => {
          this.$global.cargando = false;
        });
        this.mqttIDTemperatura =  this.$store.state.usuario.hashID + '/' + this.idSensor + '/alerta/temperatura';
        this.mqttIDHumedad =      this.$store.state.usuario.hashID + '/' + this.idSensor + '/alerta/humedad';
        this.mqttIDAmbos =        this.$store.state.usuario.hashID + '/' + this.idSensor + '/alerta/+';
        this.mqttIDEstado =       this.$store.state.usuario.hashID + '/' + this.idSensor + '/estadosensor';
        this.idSensor = miFuncionDeHash (this.idSensor) + this.idSensor;
    } else {
      this.esNuevo = true;
      this.titulo = "Añadir sensor";
      this.mqttIDTemperatura = "";
      this.mqttIDHumedad = "";
      this.mqttIDAmbos = "";
      this.mqttIDEstado = "";
    }
  },

  created() {
     this.$root.$on('save:sensordata', this.saveSensordata)
  },

  beforeDestroy() {
    this.$root.$off('save:sensordata')
  }
};
</script>

<style scoped>
.monosp {
    font-family: 'Courier', monospace;
    color: gray;
    padding-bottom:20px;
    font-size:13px; 
}
.notification {
    font-size:11px; 
    color:gray
}
.snackbar {
    font-family: 'Courier', monospace;
    color: white;
    display: flex; 
    font-size:12px; 
    align-items: center;
}
.variacion {
  padding: 0px 3px 0px 3px;
  font-style:italic;
  color: silver;
}
.pscssios {
  margin-top:60px
}
.pscssnormal {
  margin-top:5px
}
.pscssiosh {
  height:100px !important
}
.pscssnormalh {
  height:70px !important
}

</style>